
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.61 11.125a4.63 4.63 0 01-1.712-.305 3.418 3.418 0 01-1.32-.96C1.214 9.421.93 8.864.727 8.187.529 7.51.43 6.7.43 5.758c0-1.162.177-2.159.53-2.992.355-.834.86-1.467 1.517-1.899C3.138.43 3.904.211 4.773.211c.928 0 1.706.206 2.336.617.636.406 1.112 1.008 1.43 1.805.323.791.484 1.758.484 2.898 0 1.219-.182 2.248-.546 3.086-.365.839-.88 1.466-1.547 1.883-.662.417-1.435.625-2.32.625zM2.04 5.539c0 1.599.23 2.815.694 3.649.47.833 1.151 1.25 2.047 1.25.568 0 1.05-.18 1.446-.54.395-.364.692-.895.89-1.593.198-.698.297-1.513.297-2.446 0-1.135-.117-2.075-.351-2.82-.23-.75-.545-1.294-.946-1.633A2.103 2.103 0 004.72.898c-.469 0-.873.11-1.211.329-.334.218-.612.53-.836.937-.219.401-.38.888-.485 1.461-.098.573-.148 1.21-.148 1.914z","fill":"currentColor"}})])
          )
        }
      }
    